import createproject from "../assets/images/createproject.PNG";
import projectdetails from "../assets/images/projectdetails.PNG";
import projectcard from "../assets/images/projectcard.PNG";
import acceptplan from "../assets/images/acceptplan.PNG";
import projectinprogress from "../assets/images/projectinprogress.PNG";
import markprojectcompleted from "../assets/images/markprojectcompleted.PNG";
import addfeedback from "../assets/images/addfeedback.PNG";
import menuoptions from "../assets/images/menuoptions.PNG";
import walkthrough from "../assets/images/walkthrough.mp4";
import planslist from "../assets/images/planslist.PNG";
import selectedplan from "../assets/images/selectedplan.PNG";
import selectedplanextended from "../assets/images/selectedplanextended.PNG";

export const images = {
  createproject,
  projectdetails,
  projectcard,
  acceptplan,
  projectinprogress,
  markprojectcompleted,
  addfeedback,
  menuoptions,
  walkthrough,
  planslist,
  selectedplan,
  selectedplanextended
};
